import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios/axionInstance';
import { responseHandler } from '../utils';

type MutationParams = {
    id: string | number;
};

export const useDeleteOrganizationFromFirestore = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  // v3-deleteOrganization (codebase `portal`) zastąpiło `deleteOrganizationEndpoint`
  // z v1. Backend przepuszcza właściciela organizacji albo administratora
  // HotelSpot i zapisuje każdą próbę w audycie (`logs`).
  mutationFn: ({ id }) => axiosInstance.delete('/v3-deleteOrganization', {
    data: { organizationId: String(id) },
    headers: { 'Content-Type': 'application/json' },
  }).then(responseHandler),
  ...options,
});
